import { Col, Row } from "antd";

import React from "react";

interface GeneralHeaderProps {
  className?: string;
  title?: string;
  description?: string | null;
  backgroundImage?: string;
  children?: any;
}

const defaultProps: GeneralHeaderProps = {
  className: "",
  title: "Title is required",
  description: null,
};

const GeneralHeader = ({ className, title, description, children }: GeneralHeaderProps) => {
  return (
    <div className="covr-header-general">
      <Row justify="space-between" align="middle">
        <Col>
          <h1>{title}</h1>
          <p>{description}</p>
        </Col>
        <Col>{children}</Col>
      </Row>
    </div>
  );
};

GeneralHeader.defaultProps = defaultProps;

export default GeneralHeader;
